import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../components/api";
import Axios from "axios";
import AuthContext from "../context/AuthContext";
import Select from "react-select";

const EMPTY_MARKUPS = {
  single_markup: "0",
  double_markup: "0",
  triple_markup: "0",
  single_reset_markup: "0",
  double_reset_markup: "0",
  triple_reset_markup: "0",
  single_full_markup: "0",
  double_full_markup: "0",
  triple_full_markup: "0",
};

const DOUBLE_TRIPLE_FIELDS = new Set([
  "double_markup",
  "triple_markup",
  "double_reset_markup",
  "triple_reset_markup",
  "double_full_markup",
  "triple_full_markup",
]);

const PRICING_ROWS = [
  {
    field: "single_markup",
    label: "Single Recharge",
  },
  {
    field: "single_reset_markup",
    label: "Single Reset",
  },
  {
    field: "single_full_markup",
    label: "Single Full",
  },
  {
    field: "double_markup",
    label: "Double Recharge",
    doubleOrTriple: true,
  },
  {
    field: "double_reset_markup",
    label: "Double Reset",
    doubleOrTriple: true,
  },
  {
    field: "double_full_markup",
    label: "Double Full",
    doubleOrTriple: true,
  },
  {
    field: "triple_markup",
    label: "Triple Recharge",
    doubleOrTriple: true,
  },
  {
    field: "triple_reset_markup",
    label: "Triple Reset",
    doubleOrTriple: true,
  },
  {
    field: "triple_full_markup",
    label: "Triple Full",
    doubleOrTriple: true,
  },
];

const formatMoney = (value) => {
  const amount = Number(value);

  if (!Number.isFinite(amount)) {
    return "0.00";
  }

  return amount.toFixed(2);
};

function Formpr(props) {
  function refreshPage() {
    window.location.reload(false);
  }

  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(
    localStorage.getItem("authTokens")
  );

  const [notes, setcil] = useState([]);
  const [plans, setplans] = useState([]);
  const [client, setclient] = useState("");
  const [plani, setplano] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [markups, setMarkups] = useState({
    ...EMPTY_MARKUPS,
  });
  const [message, setMessage] = useState("");

  const planName = String(
    selectedPlan?.label || ""
  )
    .trim()
    .toUpperCase();

  const basicOrLight = ["BASIC", "LIGHT"].includes(
    planName
  );

  const planCost = Number(selectedPlan?.cost || 0);

  const fixedPrices = {
    single_markup: planCost,
    single_reset_markup: planCost * 0.08,
    single_full_markup: planCost * 0.25,

    double_markup: planCost * 1.75,
    double_reset_markup:
      planCost * 1.75 * 0.08,
    double_full_markup:
      planCost * 1.75 * 0.25,

    triple_markup: planCost * 2.5,
    triple_reset_markup:
      planCost * 3.25 * 0.08,
    triple_full_markup:
      planCost * 3.25 * 0.25,
  };

  const visiblePricingRows = PRICING_ROWS.filter(
    (row) => !basicOrLight || !row.doubleOrTriple
  );

  const validate = () => {
    if (
      plani === "" ||
      client === "" ||
      selectedPlan === null
    ) {
      return false;
    }

    return visiblePricingRows.every((row) => {
      const value = markups[row.field];

      return (
        String(value).trim() !== "" &&
        Number.isFinite(Number(value)) &&
        Number(value) >= 0
      );
    });
  };

  useEffect(() => {
    let isMounted = true;

    const getresellers = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/administration/dealers/`,
          {
            headers: {
              Authorization:
                `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setcil(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const getplans = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/radius/plans/internet`,
          {
            headers: {
              Authorization:
                `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setplans(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getresellers();
    getplans();

    return () => {
      isMounted = false;
    };
  }, [authTokens.access, user.username]);

  const options = notes.map((item) => ({
    label: item.fullname_en,
    value: item.dealer_id,
  }));

  const plano = plans.map((item) => ({
    label: item.plan_name,
    value: item.internet_plan_id,
    cost: item.cost,
  }));

  const handlePlanChange = (option) => {
    if (!option) {
      setplano("");
      setSelectedPlan(null);
      setMarkups({ ...EMPTY_MARKUPS });
      return;
    }

    setplano(option.value);
    setSelectedPlan(option);
    setMarkups({ ...EMPTY_MARKUPS });
    setMessage("");
  };

  const handleMarkupChange = (field, value) => {
    setMarkups((current) => ({
      ...current,
      [field]: value,
    }));
  };

  let handleSubmit = async (e) => {
    e.preventDefault();

    const submittedMarkups = {
      ...markups,
    };

    if (basicOrLight) {
      DOUBLE_TRIPLE_FIELDS.forEach((field) => {
        submittedMarkups[field] = "0";
      });
    }

    try {
      const response = await Axios.post(
        `${API_URL}/radius/plans/resellers/`,
        {
          Action: "Post",
          plan_id: plani,
          child_id: client,
          userdealer: user.username,
          ...submittedMarkups,
        },
        {
          headers: {
            Authorization:
              `Bearer ${authTokens.access}`,
          },
        }
      );

      if (response.status === 200) {
        setMessage(`${response.data}`);

        setTimeout(() => {
          setMessage("");
          refreshPage();
        }, 3000);
      }
    } catch (error) {
      console.log(error);

      const responseData = error.response?.data;
      const errorMessage =
        responseData?.error ||
        responseData?.message ||
        (typeof responseData === "string"
          ? responseData
          : "Unknown error");

      setMessage(
        `Error adding plan: ${errorMessage}`
      );

      setTimeout(() => {
        setMessage("");
      }, 3000);
    }
  };

  return (
    <div className="mod reseller-plan-pricing-form">
      <form onSubmit={handleSubmit}>
        <div className="reseller-plan-selection-grid">
          <div className="reseller-plan-form-group">
            <label htmlFor="reseller-plan-dealer">
              Dealer Name
            </label>

            <Select
              inputId="reseller-plan-dealer"
              classNamePrefix="reseller-price-select"
              placeholder="Choose Dealer"
              options={options}
              onChange={(option) =>
                setclient(option ? option.value : "")
              }
            />
          </div>

          <div className="reseller-plan-form-group">
            <label htmlFor="reseller-plan-plan">
              Plan Name
            </label>

            <Select
              inputId="reseller-plan-plan"
              classNamePrefix="reseller-price-select"
              placeholder="Choose Plan"
              options={plano}
              onChange={handlePlanChange}
            />
          </div>
        </div>

        {!selectedPlan && (
          <div className="reseller-plan-pricing-hint">
            Select a dealer and plan to configure pricing.
          </div>
        )}

        {selectedPlan && (
          <>
            <div className="reseller-plan-selected-summary">
              <span>
                Selected plan:
                <strong>{selectedPlan.label}</strong>
              </span>

              <span>
                OSS base cost:
                <strong>
                  ${formatMoney(planCost)}
                </strong>
              </span>
            </div>

            {basicOrLight && (
              <div className="reseller-plan-restriction">
                Double and Triple pricing are not available
                for BASIC or LIGHT plans.
              </div>
            )}

            <div className="reseller-plan-pricing-table">
              <div className="reseller-plan-pricing-header">
                <span>Pricing Item</span>
                <span>OSS Fixed</span>
                <span>Reseller Extra</span>
                <span>Dealer Total</span>
              </div>

              {visiblePricingRows.map((row) => {
                const fixedAmount =
                  fixedPrices[row.field];
                const enteredMarkup = Number(
                  markups[row.field] || 0
                );
                const safeMarkup = Number.isFinite(
                  enteredMarkup
                )
                  ? enteredMarkup
                  : 0;
                const total =
                  fixedAmount + safeMarkup;

                return (
                  <div
                    className="reseller-plan-pricing-row"
                    key={row.field}
                  >
                    <span className="reseller-plan-pricing-label">
                      {row.label}
                    </span>

                    <output>
                      ${formatMoney(fixedAmount)}
                    </output>

                    <div className="reseller-plan-markup-input">
                      <span>$</span>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={markups[row.field]}
                        required
                        aria-label={`${row.label} reseller extra`}
                        onChange={(event) =>
                          handleMarkupChange(
                            row.field,
                            event.target.value
                          )
                        }
                      />
                    </div>

                    <output className="reseller-plan-total">
                      ${formatMoney(total)}
                    </output>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {message && (
          <div
            className={`message ${
              message.includes("Error")
                ? "error"
                : "success"
            }`}
          >
            {message}
          </div>
        )}

        <div className="reseller-plan-submit-row">
          <button
            type="submit"
            className="btn btn-primary btn-md"
            disabled={!validate()}
          >
            Create
          </button>
        </div>
      </form>
    </div>
  );
}

export default Formpr;
